export enum CompensationType {
  GENERAL = 'GENERAL',
  SPECIAL = 'SPECIAL',
}
